import { useSelector } from 'react-redux'

import { getFeatures } from '../selectors'

export { useOrganizationFeatureEnabled } from './useOrganizationFeatureEnabled'

const NEW_EVENT_FEATURE_KEYS = [
  'ChangeTimeForShiftsWithRegistrations',
  'LocationsManagement',
  'MaintainEventSequencesAcrossEdits',
  'NewAddEventUICalendarEvent',
  'NewAddEventUILegacyFallback',
  'NewEditEventUICalendarEvent',
  'OpportunityTemplates',
  'RecurrenceTimeZoneFix',
  'SimplifyRecurringEventRules',
  'StandaloneOffers'
]

const isEnabled = (features, key) => {
  const feature = features[key]
  return feature && !!feature.enabled
}

export const useFeatureEnabled = key => {
  let features = useSelector(getFeatures)
  return (NEW_EVENT_FEATURE_KEYS.includes(key) && isEnabled(features, 'Post2025Events')) || isEnabled(features, key)
}
